import { motion } from "framer-motion";
import { steddyTransition } from "@/lib/animations";

const fadeInUp = {
  initial: { opacity: 0, y: 12 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true },
};

const CTASection = () => (
  <section id="demo" className="bg-background py-32">
    <div className="container mx-auto px-6">
      <motion.div
        {...fadeInUp}
        transition={steddyTransition}
        className="hero-gradient relative mx-auto max-w-2xl overflow-hidden rounded-3xl p-12 text-center"
      >
        <h2 className="relative z-10 text-3xl font-bold text-foreground md:text-4xl">
          Ready to go hands-off?
        </h2>
        <p className="relative z-10 mt-4 text-muted-foreground">
          Deploy Steddy.AI and let your back-office run itself. Schedule a technical demo with our
          team.
        </p>

        <div className="relative z-10 mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <input
            type="email"
            placeholder="your@email.com"
            className="w-full rounded-full border border-border bg-background px-5 py-3 text-sm text-foreground outline-none placeholder:text-muted-foreground focus:ring-2 focus:ring-primary sm:w-auto"
          />
          <a href="/login" className="btn-primary-steddy w-full text-center sm:w-auto">
            Deploy Steddy
          </a>
        </div>
      </motion.div>
    </div>
  </section>
);

export default CTASection;
